module.exports = __webpack_public_path__ + "static/media/tastemakers-campus-3.84e3239d.png";